import { onAuthStateChanged } from '@firebase/auth';
import {
    doc,
    setDoc,
    collection,
    query,
    where,
    getDocs,
    deleteDoc,
    updateDoc
} from '@firebase/firestore';

import { db, auth } from '../FirebaseConfig';
import { DATABASE_COLLECTIONS } from '../constants/DatabaseCollections';

let user;

onAuthStateChanged(auth, currentUser => {
    user = currentUser
})

export const createSplit = async (projectId, title, description, target, solde) => {
    const dateNow = Date.now()

    let split = {
        splitId: projectId + dateNow.toString(),
        projectId: projectId,
        uid: user.uid,
        title: title,
        description: description,
        creationDate: dateNow,
        solde: solde,
        target: target,
        operationsHistory: []
    }

    // Add first operation history 
    if (solde > 0) {
        split.operationsHistory.push(
            {
                date: dateNow,
                operationType: 'add',
                sum: solde
            }
        )
    }

    let docRef = doc(db, DATABASE_COLLECTIONS.SPLITS, split.splitId)

    const sendRequest = await setDoc(docRef, split)
        .then(() => {
            return split;
        })
        .catch(err => {
            throw new Error(err);
        })

    return sendRequest;
}

export const getAllSplit = async () => {
    let collectionRef = collection(db, DATABASE_COLLECTIONS.SPLITS)

    let q = query(collectionRef, where('uid', '==', user.uid));
    let querySnapshot = await getDocs(q);

    let allSplit = []

    querySnapshot.forEach((doc) => {
        let project = doc.data()
        allSplit.push(project)
    });

    return allSplit
}

export const deleteSplitById = async (splitId) => {
    let docRef = doc(db, DATABASE_COLLECTIONS.SPLITS, splitId)

    const sendRequest = await deleteDoc(docRef)
        .then(() => {
            return
        })
        .catch(err => {
            throw new Error(err);
        })

    return sendRequest;
}

const updateOperationsHistory = (solde, lastSolde, operationsHistory) => {
    const dateNow = Date.now()

    if (solde === lastSolde) {
        return operationsHistory
    }

    let operationSum = solde > lastSolde ? solde - lastSolde : lastSolde - solde;

    const newHistory = {
        date: dateNow,
        operationType: solde > lastSolde ? 'add' : 'pull',
        sum: operationSum
    }

    const maxOperationsInHistory = 50;
    let newOperationsHistory = [newHistory, ...operationsHistory];
    newOperationsHistory = newOperationsHistory.filter((operation, index) => index < maxOperationsInHistory)

    return newOperationsHistory

}

export const modifySplitSolde = async (splitId, lastSolde, solde, operationsHistory = []) => {
    let docRef = doc(db, DATABASE_COLLECTIONS.SPLITS, splitId)

    const newOperationsHistory = updateOperationsHistory(solde, lastSolde, operationsHistory)

    const documentModifications = {
        solde: solde,
        operationsHistory: newOperationsHistory
    }

    const sendRequest = await updateDoc(docRef, documentModifications)
        .then(() => {
            return newOperationsHistory;
        }).catch(err => {
            throw err
        })

    return sendRequest;
}

export const modifySplit = async (splitId, title, description, target, solde, lastSolde, operationsHistory = []) => {
    let docRef = doc(db, DATABASE_COLLECTIONS.SPLITS, splitId)

    const newOperationsHistory = updateOperationsHistory(solde, lastSolde, operationsHistory)

    const splitModifications = {
        title: title,
        description: description,
        target: target,
        solde: solde,
        operationsHistory: newOperationsHistory,
    }

    const sendRequest = await updateDoc(docRef, splitModifications)
        .then(() => {
            return splitModifications;
        }).catch(err => {
            throw err
        })

    return sendRequest;
}

